import { CeLocationRow } from 'shared/stations-service/locations.service';

export const getAddressLine = (location: CeLocationRow) =>
    [location?.address, location?.city, location?.country].filter(Boolean).join(', ');
